import { render, staticRenderFns } from "./NoticManage.vue?vue&type=template&id=58a16add&scoped=true"
import script from "./NoticManage.vue?vue&type=script&lang=js"
export * from "./NoticManage.vue?vue&type=script&lang=js"
import style0 from "./NoticManage.vue?vue&type=style&index=0&id=58a16add&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58a16add",
  null
  
)

export default component.exports